import { render, staticRenderFns } from "./JavascriptComponentsSection.vue?vue&type=template&id=db6ff940&"
import script from "./JavascriptComponentsSection.vue?vue&type=script&lang=js&"
export * from "./JavascriptComponentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JavascriptComponentsSection.vue"
export default component.exports